module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LVYoIW/tc-custom/9789948751533.jpg?1725723409098",
      "alt": "This image is the cover for the book It Is Okay"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("It Is Okay\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Experience the different emotions from children all over the world. Feel excited with Arjan. Feel angry with Mehmet. Feel shy with Adelina. Feel scared with Mohamed. Feel impatient with Bella. Feel nervous with Abayomi. Feel happy with Yinou. Feel disappointed with Liam. Feel amused with Eman. Feel tired with Louise. Feel jealous with Erzebeth. Feel sad with Emily. Feel bored with Alejandro. Feel anxious with Andreas. Feel amused with Adel. And discover that it is okay to feel.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Fatema Alaali\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Fatema Alaali graduated with a bachelor’s degree in Banking and Finance. She is currently taking her master’s degree in Education. She aims to make the world a better place.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0